import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "content", "input"]
  static values = {
    activeClass: {type: String, default: "toggle-btn-on"},
    inactiveClass: {type: String, default: "toggle-btn-off"}
  }

  connect() {
    if (this.hasInputTarget) {
      this.updateToggleState(this.inputTarget.value === '1')
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.hasInputTarget) {
      const newValue = this.inputTarget.value === '1' ? '0' : '1'
      this.inputTarget.value = newValue
      this.updateToggleState(newValue === '1')

      // Dispatch change event for form handling
      const changeEvent = new Event('change', {bubbles: true})
      this.inputTarget.dispatchEvent(changeEvent)
    }
  }

  updateToggleState(enabled) {
    if (this.hasToggleTarget && this.hasContentTarget) {
      this.toggleTarget.classList.toggle(this.activeClassValue, enabled)
      this.toggleTarget.classList.toggle(this.inactiveClassValue, !enabled)

      this.contentTarget.classList.toggle('d-none', !enabled)
    }
  }
}
